/**
 * bohemia-cart-clear.js
 *
 * Vide automatiquement le panier Shopify quand le client revient
 * sur la page /pages/merci après un paiement Stripe réussi.
 *
 * Le paramètre ?session_id=cs_... dans l'URL confirme que le client
 * vient bien de finaliser un paiement (Stripe l'ajoute automatiquement).
 *
 * Installation : ajouter ce fichier dans Assets du thème, puis le
 * charger dans theme.liquid juste avant </body> :
 *   <script src="{{ 'bohemia-cart-clear.js' | asset_url }}" defer></script>
 */
 
(function () {
  // On agit uniquement sur la page /pages/merci avec un session_id Stripe
  const isMerciPage = window.location.pathname === '/pages/merci';
  const hasStripeSession = new URLSearchParams(window.location.search).has('session_id');
 
  if (!isMerciPage || !hasStripeSession) return;
 
  // Vide le panier Shopify
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  })
    .then(() => {
      console.log('Panier vidé après paiement Stripe.');
      // Met à jour le compteur du panier dans le header Dawn si présent
      document.querySelectorAll('.cart-count-bubble, #cart-icon-bubble').forEach((el) => {
        const countEl = el.querySelector('[aria-hidden="true"]');
        if (countEl) countEl.textContent = '0';
      });
    })
    .catch((err) => {
      console.warn('Impossible de vider le panier:', err);
    });
})();